import CloseIcon from '@mui/icons-material/Close';
import { Box, Card, CardActions, IconButton, Typography } from '@mui/material';
import React from 'react';

import { snackMessageStyles } from '../style';
import { SnackMessageProps } from '../types';
import { getNotificationClass, getNotificationTypeIcon } from '../util';

const SimpleSnackMessage = React.forwardRef<any, SnackMessageProps>(
  ({ message, closeSnackbar, variant }, ref) => {
    const classes = snackMessageStyles();

    const handleDismiss = (event: React.MouseEvent) => {
      event.stopPropagation();
      closeSnackbar();
    };

    return (
      <Card className={classes.card} ref={ref}>
        <CardActions className={getNotificationClass(variant, classes)}>
          <Box className={classes.notificationMessageContainer}>
            <Box
              className={`${getNotificationClass(variant, classes)} ${classes.notificationIcon}`}
            >
              {getNotificationTypeIcon(variant)}
            </Box>
            <Typography variant='body2' className={classes.notificationMessage}>
              {message}
            </Typography>
          </Box>
          <Box className={classes.closeButton}>
            <IconButton onClick={handleDismiss} size='small'>
              <CloseIcon fontSize='small' />
            </IconButton>
          </Box>
        </CardActions>
      </Card>
    );
  }
);

export default SimpleSnackMessage;
